import React, { useState, useEffect } from 'react';
import './carousel.css';

// Import professional signup images (reusing same images)
import hairdresserImage from '../../assets/images/professional-signup/hairdresser.png';
import nailTechImage from '../../assets/images/professional-signup/nail-tech.png';
import barberImage from '../../assets/images/professional-signup/barber.png';
import appointmentImage from '../../assets/images/professional-signup/appointment.png';

const ClientCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      title: "Book Instantly",
      subtitle: "Find and book appointments in seconds",
      image: hairdresserImage,
      color: "#007EA0"
    },
    {
      title: "Discover Top Salons",
      subtitle: "Browse reviews and find your perfect match",
      image: nailTechImage,
      color: "#2AAECC"
    },
    {
      title: "Never Miss Out",
      subtitle: "Get reminders and manage all your bookings",
      image: barberImage,
      color: "#3BBFE5"
    },
    {
      title: "Your Beauty Journey",
      subtitle: "Track your appointments and favourite stylists",
      image: appointmentImage,
      color: "#4DD0FF"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="auth-carousel">
      {slides.map((slide, index) => (
        <div 
          key={index} 
          className={`auth-carousel-slide ${index === currentSlide ? 'active' : ''}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <div className="auth-carousel-overlay">
            <div className="auth-carousel-content">
              <h2>{slide.title}</h2>
              <p>{slide.subtitle}</p>
            </div>
          </div>
        </div>
      ))}
      
      <div className="auth-carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`auth-carousel-indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ClientCarousel;